import { Individu } from '@/models/Individu';
import { utils } from '@/util';
import { IDB } from "./idb";

import $inoe from "@/config";
import { Activite } from '@/models/Activite';
import { AnneeScolaireDocument } from '@/models/AnneeScolaireDocument.js';
import { Autorisations } from '@/models/Autorisations';
import { ClasseScolaireDocument } from '@/models/ClasseScolaireDocument.js';
import { ClasseScolaireEnseignantDocument } from '@/models/ClasseScolaireEnseignantDocument.js';
import { ClasseScolaireNiveauDocument } from '@/models/ClasseScolaireNiveauDocument.js';
import { DossierDocument } from '@/models/DossierDocument';
import { EnseignantScolaireDocument } from '@/models/EnseignantScolaireDocument.js';
import { EtablissementScolaireDocument } from '@/models/EtablissementScolaireDocument.js';
import { EtablissementScolaireNiveauDocument } from '@/models/EtablissementScolaireNiveauDocument.js';
import { GroupeIndividu } from '@/models/GroupeIndividu';
import { HistoScolarite } from '@/models/HistoScolarite';
import { NiveauScolaireDocument } from '@/models/NiveauScolaireDocument';
import { PaletteDocument } from '@/models/PaletteDocument';
import { Pointage } from '@/models/Pointage';
import { PointageDetailInoeDocument } from '@/models/PointageDetailInoeDocument.js';
import { Supplement } from '@/models/Supplement';
import { SupplementPointageDocument } from '@/models/SupplementPointageDocument.js';
import { TypeActivite } from '@/models/TypeActivite';
import { VieQuoRegimeAliDocument } from "@/models/VieQuoRegimeAliDocument";
import { VieQuotidienneDocuments } from '@/models/VieQuotidienneDocument';
import { Ville } from '@/models/Ville';
import { MemDB } from "./memdb";

const PouchDB = require("pouchdb").default;
PouchDB.plugin(require('pouchdb-find').default);

const DB_TRACE = "[ANMOBI][DB]";
const traceDb = (step: string, data?: any) => {
  const stamp = new Date().toISOString();
  if (typeof data === "undefined") {
    console.log(`${DB_TRACE}[${stamp}] ${step}`);
    return;
  }
  console.log(`${DB_TRACE}[${stamp}] ${step}`, data);
};
const traceDbWarn = (step: string, data?: any) => {
  const stamp = new Date().toISOString();
  if (typeof data === "undefined") {
    console.warn(`${DB_TRACE}[${stamp}] ${step}`);
    return;
  }
  console.warn(`${DB_TRACE}[${stamp}] ${step}`, data);
};
const traceDbError = (step: string, data?: any) => {
  const stamp = new Date().toISOString();
  if (typeof data === "undefined") {
    console.error(`${DB_TRACE}[${stamp}] ${step}`);
    return;
  }
  console.error(`${DB_TRACE}[${stamp}] ${step}`, data);
};

class DB implements IDB {
  localDB: any;
  memDB: any;
  remoteDB: any;
  syncHandler: any;
  localDBSize: number = 0;
  remoteDBSize: number = 0;


  loadMemDB(ldb: any): Promise<any> {
    if (this.memDB) {
      this.memDB.docs = [];
      delete this.memDB.docs;
    }
    this.memDB = new MemDB(ldb);
    return this.memDB.load();
  }
  load(): Promise<any> {
    return this.loadMemDB(this.localDB);
  }
  public loadChanges(info: Array<any>): void {
    this.memDB.loadChanges(info);
  }

  //PouchDB Params
  //not used ?
  // openSession(url: String, username: String, password: String) {
  //   var me = this;
  //   return new Promise(function (resolve, reject) {
  //     //Init    
  //     if (url === "" || username === "" || password === "") {
  //       reject({ status: 400, data: {} })
  //     }
  //     me.localDB = new PouchDB($inoe.getRemoteDBName(), { auto_compaction: true });
  //     me.initRemoteDB(url, username, password, true);

  //     me.localDB.info().then((info: any) => {
  //       me.localDBSize = info.doc_count;
  //       console.log("LocalDB", me.localDBSize)
  //       me.remoteDB.info().then((info: any) => {
  //         me.initRemoteDB(url, username, password, false);
  //         me.remoteDBSize = info.doc_count;
  //         console.log("RemoteDB", me.remoteDBSize);
  //         resolve({ status: 200, data: { localDBSize: me.localDBSize, remoteDBSize: me.remoteDBSize, isOffline: false } });
  //       }).catch((error: any) => {
  //         if (me.localDBSize === 0) {
  //           reject({ status: 400, error: error })
  //         } else {
  //           resolve({ status: 200, data: { localDBSize: me.localDBSize, remoteDBSize: me.localDBSize, isOffline: true } });
  //         }
  //       })
  //     }).catch((error: any) => {
  //       reject({ status: 400, error: error })
  //     })
  //   });
  // }

  initLocalDB(): Promise<any> {
    let me = this;
    return new Promise(function (resolve, reject) {
      me.localDB = new PouchDB($inoe.getRemoteDBName(), { auto_compaction: true });
      traceDb("initLocalDB", { dbName: $inoe.getRemoteDBName() });
      resolve(me.localDB);
    });
  }
  initRemoteDB(url: String, username: String, password: String, withParams: boolean) {
    let me = this;
    return new Promise(function (resolve, reject) {
      traceDb("initRemoteDB:start", {
        url,
        username,
        withParams,
        hasPassword: !!password,
        online: navigator.onLine
      });
      me.remoteDB = new PouchDB(url, {
        fetch: function (url: string, opts: any) {
          if (withParams) {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 30000);
            url = `${url}?_dc=${Date.now()}`
            opts.signal = controller.signal
          }
          const authorization = $inoe.getAuthorisation() || btoa(username + ":" + password);

          opts.headers.set("Authorization", "Basic " + authorization);
          traceDb("initRemoteDB:fetch", { url, withParams });
          return PouchDB.fetch(url, opts).then((res: any) => {
            if (res && res.status === 401) {
              console.warn("CouchDB 401 Not Authenticated:", url);
              traceDbWarn("initRemoteDB:fetch-401", { url, status: res.status });
            }
            return res;
          }).catch((error: any) => {
            traceDbError("initRemoteDB:fetch-error", {
              url,
              message: error && error.message,
              name: error && error.name
            });
            throw error;
          });
        },
      });
      traceDb("initRemoteDB:done", { url });
      resolve(me.remoteDB);
    });
  }

  getLocalDBSize(): Promise<any> {
    let me = this
    return new Promise(function (resolve, reject) {
      me.localDB.info().then((info: any) => {
        me.localDBSize = info.doc_count;
        console.log("LocalDB", me.localDBSize);
        resolve(me.localDBSize);
      }).catch(() => {
        me.localDBSize = 0;
        resolve(me.localDBSize);
      })
    })
  }

  getRemoteDBSize(): Promise<any> {
    let me = this
    return new Promise(function (resolve, reject) {
      me.remoteDB.info().then((info: any) => {
        me.remoteDBSize = info.doc_count;
        console.log("RemoteDB", me.remoteDBSize);
        resolve(me.remoteDBSize);
      }).catch(() => {
        me.remoteDBSize = 0;
        resolve(me.remoteDBSize);
      })
    })
  }

  replicate(config: any) {
    let me = this;
    return me.localDB.replicate.from(me.remoteDB, config);
  }
  replicateFrom(config: any) {
    let me = this;
    if (!me.localDB) {
      console.error(" localDB est undefined dans replicateFrom");
      throw new Error("LocalDB n'est pas initialisée");
    }
    if (!me.remoteDB) {
      console.error("remoteDB est undefined dans replicateFrom");
      throw new Error("RemoteDB n'est pas initialisée");
    }
    
    return me.localDB.replicate.from(me.remoteDB, config);
  }
  replicateTo() {
    let me = this;    
    if (!me.localDB) {
      console.error("❌ localDB est undefined dans replicateTo");
      throw new Error("LocalDB n'est pas initialisée");
    }
    if (!me.remoteDB) {
      console.error("❌ remoteDB est undefined dans replicateTo");
      throw new Error("RemoteDB n'est pas initialisée");
    }
    
    return me.localDB.replicate.to(me.remoteDB, {
      live: true,
      retry: true,
      filter: function (doc:any) {
        return (doc.typedoc === 'pointageANMobi' ||doc.typedoc === 'supplementANMobi') && doc.isInoe===false;
      }
    });
  }
  replicateToOnce() {
    let me = this;
    return me.localDB.replicate.to(me.remoteDB, {
      live: false,
      retry: true,
      filter: function (doc:any) {
        return (doc.typedoc === 'pointageANMobi' ||doc.typedoc === 'supplementANMobi') && doc.isInoe===false;
      }
    });
  }
  sync(config: any) {
    let me = this;
    const syncId = `dbsync-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    traceDb("sync:start", {
      syncId,
      config,
      hasLocalDB: !!me.localDB,
      hasRemoteDB: !!me.remoteDB,
      online: navigator.onLine
    });
    if (!me.localDB) {
      console.error(" localDB est undefined dans sync");
      traceDbError("sync:missing-localdb", { syncId });
      throw new Error("LocalDB n'est pas initialisée. Veuillez d'abord appeler initLocalDB()");
    }
    if (!me.remoteDB) {
      console.error(" remoteDB est undefined dans sync");
      traceDbError("sync:missing-remotedb", { syncId });
      throw new Error("RemoteDB n'est pas initialisée. Veuillez d'abord appeler initRemoteDB()");
    }
    
    if (me.syncHandler) {
      traceDbWarn("sync:cancel-previous-handler", { syncId });
      me.syncHandler.cancel()
    }

    if (config && config.direction === "push") {
      traceDb("sync:push-only-mode", { syncId, config });
      me.syncHandler = me.replicateToOnce();
      me.syncHandler
        .on("change", (info: any) => {
          traceDb("sync:push-change", {
            syncId,
            docs: info && info.docs ? info.docs.length : undefined,
            pending: info && info.pending
          });
        })
        .on("paused", (err: any) => {
          traceDbWarn("sync:push-paused", { syncId, err, online: navigator.onLine });
        })
        .on("active", () => {
          traceDb("sync:push-active", { syncId });
        })
        .on("denied", (err: any) => {
          traceDbWarn("sync:push-denied", { syncId, err });
        })
        .on("complete", (info: any) => {
          traceDb("sync:push-complete", { syncId, info });
        })
        .on("error", (err: any) => {
          traceDbError("sync:push-error", { syncId, err, online: navigator.onLine });
        });
      return me.syncHandler;
    }
    
    me.syncHandler = me.replicateFrom(config);
    me.syncHandler
      .on("change", (info: any) => {
        traceDb("sync:pull-change", {
          syncId,
          docs: info && info.docs ? info.docs.length : undefined,
          pending: info && info.pending,
          direction: info && info.direction
        });
      })
      .on("paused", (err: any) => {
        traceDbWarn("sync:pull-paused", {
          syncId,
          err,
          online: navigator.onLine
        });
      })
      .on("active", () => {
        traceDb("sync:pull-active", { syncId });
      })
      .on("denied", (err: any) => {
        traceDbWarn("sync:pull-denied", { syncId, err });
      })
      .on("complete", (info: any) => {
        traceDb("sync:pull-complete", { syncId, info });
      })
      .on("error", (err: any) => {
        traceDbError("sync:pull-error", { syncId, err, online: navigator.onLine });
      });

    if (config && config.live === true) {
      const pushHandler = me.replicateTo();
      pushHandler
        .on("change", (info: any) => {
          traceDb("sync:push-change", {
            syncId,
            docs: info && info.docs ? info.docs.length : undefined,
            pending: info && info.pending
          });
        })
        .on("paused", (err: any) => {
          traceDbWarn("sync:push-paused", { syncId, err, online: navigator.onLine });
        })
        .on("active", () => {
          traceDb("sync:push-active", { syncId });
        })
        .on("denied", (err: any) => {
          traceDbWarn("sync:push-denied", { syncId, err });
        })
        .on("complete", (info: any) => {
          traceDb("sync:push-complete", { syncId, info });
        })
        .on("error", (err: any) => {
          traceDbError("sync:push-error", { syncId, err, online: navigator.onLine });
        });
    } else {
      traceDbWarn("sync:push-skipped", {
        syncId,
        reason: "non-live pull sync",
        config
      });
    }
  
    return me.syncHandler;
  }
  reset() {
    console.warn("Suppression des données ...")
    let me = this;
    me.memDB = undefined;
    me.remoteDB = undefined;
    me.localDBSize = -1;
    me.remoteDBSize = -1;
    return me.localDB.destroy();
  }

  checkSecretCode(code: string, etablissementId: number) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }
  logout() {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }
  listUsers() {
    return this.localDB.get("users");
  }
  listUsersFromRemote() {
    return this.remoteDB.get("users");
  }
  usersLogged() {
    return this.localDB.get("usersLogged");
  }
  //Not used

  //Document Handler
  ajouterDocument(document: any) {
    let me = this;
    console.log("put document")
    console.log(document)
    return me.localDB.put(document);
  }
  ajouterDocumentRemote(document: any) {
    let me = this;
    return me.remoteDB.put(document);
  }
  supprimerDocument(document_Id: string) {
    let me = this;
    return me.localDB
      .get(document_Id)
      .then(function (doc: any) {
        doc._deleted = true;
        return me.localDB.put(doc);
      }).catch((error: any) => {
        console.error(error)
      })
  }
  bulkDocuments(listDocuments: Array<any>) {
    let me = this;
    let failDoc: Array<any> = []
    return new Promise((resolve, reject) => {
      me.localDB.bulkDocs(listDocuments).then((rep: any) => {
        rep.forEach((element: any) => {
          if (!element.ok) {
            failDoc.push(element)
          }
        });
      }).finally(() => {
        resolve(failDoc)
      }).catch((error: any) => {
        console.error(error)
        reject(error)
      })
    });
  }
  //Document Handler


  //Etablissement & Activites
  public getEtablissements() {
    return this.memDB.docs["EtablissementDocument"]
  }
  listTypesActivites(): Array<TypeActivite> {
    return this.memDB.docs["TypeActiviteDocument"]
  }
  //Etablissement & Activites


  //Frise
  listEcoles(): Array<EtablissementScolaireDocument> {
    return this.memDB.docs["EtablissementScolaireDocument"];
  }
  listClasses(): Array<ClasseScolaireDocument> {
    return this.memDB.docs["ClasseScolaireDocument"];
  }
  listInstit(): Array<EnseignantScolaireDocument> {
    return this.memDB.docs["EnseignantDocument"];
  }
  listNiveau(): Array<NiveauScolaireDocument> {
    return this.memDB.docs["NiveauScolaireDocument"];
  }
  listEtablissementScolaireNiveau(): Array<EtablissementScolaireNiveauDocument> {
    return this.memDB.docs["EtablissementScolaireNiveauDocument"];
  }
  HistoScolarite(): Array<HistoScolarite> {
    return this.memDB.docs["HistoScolariteIndividuDocument"];
  }
  currentAnneeScolaire(): AnneeScolaireDocument | undefined {
    let list = this.memDB.docs["AnneeScolaireDocument"] as Array<AnneeScolaireDocument>;
    let currentDate = utils.getCurrentTimeNow();
    if (typeof list !== 'undefined' && list.length !== 0) {
      let annee = list.find((a: AnneeScolaireDocument) => {
        let dateDebut = utils.getDateFromString(a.getDatedebut(), "YYYY-MM-DD HH:mm:ss");
        let dateFin = utils.getDateFromString(a.getDatefin(), "YYYY-MM-DD HH:mm:ss");
        return currentDate.isBetween(dateDebut, dateFin) && !a.isObsolete();
      });
      return annee;
    } else
      return undefined;
  }
  listClasseScolaireNiveau(): Array<ClasseScolaireNiveauDocument> {
    return this.memDB.docs["ClasseScolaireNiveauDocument"];
  }
  listClasseScolaireEnseignant(): Array<ClasseScolaireEnseignantDocument> {
    return this.memDB.docs["ClasseScolaireEnseignantDocument"];
  }
  listAutorisations(): Array<Autorisations> {
    return this.memDB.docs["AutorisationsDocument"];
  }
  listAutorisationEtablissement(): Array<Autorisations> {
    return this.memDB.docs["AutorisationEtablissementDocument"];
  }
  listVille(): Array<Ville> {
    return this.memDB.docs["VilleDocument"];
  }
  getPalette(id: number): PaletteDocument {
    return this.memDB.findOne({
      doctype: "PaletteDocument",
      fkey: "id",
      fvalue: id
    })
  }

  getGroupe(id: number): GroupeIndividu {
    return this.memDB.findOne({
      doctype: "GroupeIndividuDocument",
      fkey: "id",
      fvalue: id
    })
  }

  getRegimesAlim(): Array<VieQuotidienneDocuments> {
    let listVieQuoti: Array<VieQuotidienneDocuments> = this.memDB.docs["VieQuotidienneDocument"];
    return listVieQuoti.filter((vieQuo: VieQuotidienneDocuments) => vieQuo.getDtype() === "RegimeAlimentaire");
  }

  getVieQuoRegimeAli(): Array<string> {
    let vieQuoRegimeAli: Array<string> = []
    this.memDB.docs["VieQuoRegimeAliDocument"].forEach((element: VieQuoRegimeAliDocument) => {
      vieQuoRegimeAli.push(element.getType_regime())
    });
    return [...new Set(vieQuoRegimeAli)]
  }

  //Frise

  //Grille Pointage
  listSupplementsActifs(date: any, activite_id: number) {
    let me = this;
    let listsupplementsactifs: Array<Supplement> = [];

    return new Promise<Array<Supplement>>((resolve, reject) => {
      me.localDB.allDocs({
        include_docs: true,
        attachments: true,
        startkey: 'supplementAN' + date.format('YYYYMMDD') + activite_id,
        endkey: 'supplementAN' + date.format('YYYYMMDD') + activite_id + '\uffff'
      }).then((listrep: any) => {
        listrep.rows.forEach((rep: any) => {
          let supplement = new Supplement(rep.doc);
          listsupplementsactifs.push(supplement)
        });
        resolve(listsupplementsactifs)
      }).catch((error: any) => {
        console.error(error)
        resolve([])
      })
    })
  }
  listPointages(date: any, currentActiviteId: number) {
    let me = this;
    let listpointageactifs: Array<Pointage> = [];
    return new Promise<Array<Pointage>>((resolve, reject) => {
      me.localDB.allDocs({
        include_docs: true,
        attachments: true,
        startkey: 'pointageAN' + date.format('YYYYMMDD') + currentActiviteId,
        endkey: 'pointageAN' + date.format('YYYYMMDD') + currentActiviteId + '\uffff'
      }).then((listrep: any) => {
        listrep.rows.forEach((rep: any) => {
          let pointage = new Pointage(rep.doc);
          listpointageactifs.push(pointage)
        });
        resolve(listpointageactifs)
      }).catch((error: any) => {
        console.error(error)
        resolve([])
      })
    })
  }

  getConfig() {
    return new Promise((resolve,reject)=>{
     return Promise.all([
       this.localDB.get("version"),
       this.localDB.get("users"),
       this.localDB.get("infoDossier"),
     ]).then(responses=>{
       resolve({
         version:responses[0],
         users:responses[1],
         infoDossier:responses[2]
       })
     }).catch(e=>{
       reject(e)
     })
    })
    
   
   }
 
  //Individu & Infos
  getIndividus(): Array<Individu> {
    return this.memDB.docs["IndividuDocument"]
  }
  findDossier(): DossierDocument {
    return this.memDB.findOne({
      doctype: "DossierDocument",
      fkey: "id",
      fvalue: -1
    })
  }
  getPointageDetailInoe(id: number): PointageDetailInoeDocument {
    let pdetail: PointageDetailInoeDocument = this.memDB.find({
      doctype: "PointageDetailDocument",
      fkey: "id",
      fvalue: id
    });
    return pdetail;

  }
  getSupplementPointageInoe(id: number): SupplementPointageDocument {
    let supp: SupplementPointageDocument = this.memDB.find({
      doctype: "SupplementPointageDocument",
      fkey: "id",
      fvalue: id
    });
    return supp;
  }
  getActiviteFromId(id: number): Activite {
    return this.memDB.findOne({
      doctype: "ActiviteDocument",
      fkey: "id",
      fvalue: id
    })
  }
  
  getInfoDossierMobi() {
    let me = this;
    return me.localDB.get("infoDossier");
  }

  getMobiErrorLogsDocuments() {
    let me = this;
    return me.localDB.get("MobiErrorLogs");
  }

  getDateLastSynchroMobi() {
    let me = this;
    return me.localDB.get("dateExport");
  }
}

export default new DB();
